import React from 'react';
import { Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { NavLink } from '../../../../lib/components/link';
import MenuType from '../../../../lib/proptypes/menu.proptypes';
import classes from './desktopNav.css';

const QuickLinkMenuItem = item => {
  if (!item.action && !item.url) {
    // Bail if we don't have the information that we need here
    return null;
  }

  return (
    <NavLink key={item.key} className={classes.linkText} activeClassName="active" {...item} />
  );
};


const DesktopQuickLinks = ({ menu }) => (
  <Menu secondary borderless attached="bottom" className={classes.quickLinksMenu}>
    <Menu.Item
      className={classes.menuLabel}
      header
    >
      Quick Links
    </Menu.Item>
    {!menu.length && <Menu.Item className={classes.menuLabel}>Loading</Menu.Item>}
    {menu.map(QuickLinkMenuItem)}
  </Menu>
);

DesktopQuickLinks.defaultProps = {
  menu: [],
};

DesktopQuickLinks.propTypes = {
  menu: MenuType.isRequired,
};


const mapStateToProps = state => ({
  menu: state.nav.quickLinks,
});


export default connect(mapStateToProps)(DesktopQuickLinks);



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/DesktopQuickLinks.js